'use client';

import { createContext, useContext } from 'react';
import { DEFAULT_FONT } from './tapestryText';

/**
 * The classic canvas's skin (TT-1133): the handful of values that make it a
 * chalkboard — white ink, `screen` blending, chalk puffs and dust, the dark
 * photographic surface, chalk-yellow new text — gathered so a host can run
 * the same opening (symbol roles, slot fill, dwell, pen) on paper for the
 * scene system, which letters its opening minutes exactly like classic and
 * hands over to the planned board when it lands.
 *
 * `chalkboard` is the classic look and the default; `paper` is the scene
 * lab's: ink on white, normal blending, the pen without its chalk.
 */
export const SKINS = {
  chalkboard: {
    ink: '#ffffff',
    newInk: '#ffe680',
    blend: 'screen',
    chalk: true,
    surface: null, // the canvas keeps its photographic background
    title: '#ffffff',
    titleShadow: '0 0 4px rgba(0,20,40,0.9), 0 0 4px rgba(0,20,40,0.9)',
    font: DEFAULT_FONT,
  },
  paper: {
    ink: '#1f1f1f',
    newInk: '#3aa655',
    blend: 'normal',
    chalk: false,
    surface: '#ffffff',
    title: '#1f1f1f',
    titleShadow: 'none',
    font: 'Patrick Hand', // the scene's caps face (the host loads it)
  },
};

const TapestrySkinContext = createContext(SKINS.chalkboard);

/** A skin by name; anything unknown is the chalkboard. */
export function resolveSkin(skin) {
  return SKINS[skin] || SKINS.chalkboard;
}

export const TapestrySkinProvider = TapestrySkinContext.Provider;

export function useTapestrySkin() {
  return useContext(TapestrySkinContext);
}
